module.exports = __webpack_public_path__ + "media/printed-materials/educators-01-poster (9ea552fb-f171-4afe-b917-97ef9130b3b6)-7e98b7a1.jpg";